export default __webpack_public_path__ + "static/media/480_dummy2016-immobilien01-mobile-de.799bd5f5.png";